//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
  name: 'Searchbar',
  props: { hidden: { type: Boolean, default: false } },
  data() {
    return {
      industry: [
        {
          value: 'I100',
          label: '資訊科技',
        },
        {
          value: 'I200',
          label: '傳產製造',
        },
        {
          value: 'I300',
          label: '工商服務',
        },
        {
          value: 'I400',
          label: '民生服務',
        },
        {
          value: 'I500',
          label: '文教傳播',
        },
      ],
      searchPayload: {
        startDate: null,
        teachingFieldIds: null,
        industryCategoryIds: null,
        areaIds: null,
      },
    };
  },
  computed: {
    ...mapGetters('common', ['areaLocalTree']),
    ...mapGetters('lecturer', ['teachingFields']),
  },
  methods: {
    onChangeItem() {
      this.$emit('search', this.searchPayload);
    },
  },
};
